import React, { useCallback, useState, useLayoutEffect, useMemo } from "react";
import { Row, Col } from "react-bootstrap"
import FilterReport from "../header/FilterReport"
import styles from "../style.module.css"
import { Tag } from "rsuite"
import { format,startOfMonth, endOfMonth } from "date-fns"
import axiosService from "../../../utils/axios.service";
import _ from "lodash"
import { Line } from '@ant-design/plots';
import { Table, Spin } from "antd"
import "../scss/report.scss"
import StorageService from "../../../utils/storage.service";
import { Tooltip } from "antd";

const ReportStoreBooingPrice = () => {
    const columns = [
        { dataIndex: 'date', title: 'Thời gian', width: 130  },
        // { field: 'totalOrder', headerName: 'Số đơn hàng', type: "number", width: 160, styles: { color: "red" } },
        {
            dataIndex: 'totalMore',
            title:   <Tooltip className="show-tooltip" title='Tông tiền những đơn hàng nợ phải thu từ khách hàng hẹn lịch đến làm dịch vụ lần đầu tiên'> Doanh thu dự kiến  <i className="fas fa-info-circle"></i></Tooltip>,
            width: 120 ,
            align: "center",
            render: (data) => {
                return (
                    <p className="text4">{convertCurrency(data)}</p>
                )
            },
        },
        {
            dataIndex: 'paidD',
            title:   <Tooltip className="show-tooltip" title='Tông tiền những đơn hàng nợ, phải thu từ khách hàng hẹn lịch, điều kiện= làm dịch vụ lần đầu tiên nhưng vì lý do cá nhân không đến, huỷ lịch đặt... '> Doanh thu đơn huỷ  <i className="fas fa-info-circle"></i></Tooltip>,
            width: 120 ,
            align: "center",
            render: (data) => {
                return (
                    <p className="text3">{convertCurrency(data)}</p>
                )
            },
        },
        {
            dataIndex: 'totalPaid',
            title:   <Tooltip className="show-tooltip" title='Tổng tiền đã thu từ những khách hẹn lịch, đến làm dịch vụ thành công và thanh toán tiền.'> Thực thu dự kiến  <i className="fas fa-info-circle"></i></Tooltip>,
            width: 150 ,
            align: "center",
            render: (data) => {
                return (
                    <p className="text6">{convertCurrency(data)}</p>
                )
            },
        },
        
        {
            dataIndex: 'totalAll',
            title:   <Tooltip className="show-tooltip" title='Tổng tất cả tiền khách hàng đến thanh toán nợ hoặc mua mới đơn hàng trong thời gian.'> Tổng thực thu  <i className="fas fa-info-circle"></i></Tooltip>,
            width: 120 ,
            align: "center",
            render: (data) => {
                return (
                    <p className="text1">{convertCurrency(data)}</p>
                )
            },
        },
    ];
    var date = new Date();
    date.setDate(date.getDate() - 1);
    const [startDate, setStartDate] = useState(format(new Date(startOfMonth(date)),"yyyy-MM-dd"))
    const [endDate, setEndDate] = useState(format(new Date(endOfMonth(date)), 'yyyy-MM-dd'))
    const [store, setStore] = useState(
        (JSON.parse(StorageService.getItem("user_info")) && JSON.parse(StorageService.getItem("user_info")).role == 3) ?
            JSON.parse(StorageService.getItem("user_info")).stores[0].id
        : parseInt(StorageService.getItem("currentStore")) )
    const [sortBy, setSortBy] = useState(0)
    const [totalPaid, setTotalPaid] = useState(0)
    const [totalOrderNew, setTotalOrderNew] = useState(0)
    const [totalOrderTriet, setTotalOrderTriet] = useState(0)
    const [ordersByDaysCountBooking, setOrdersByDaysCountBooking] = useState([])
    const [rows, setRows] = useState([])
    const [loading, setLoading] = useState(true);
    const [isExport, setIsExport] = useState(false)
    const handleRangeDate = useCallback((sDate, eDate) => {
        setStartDate(sDate)
        setEndDate(eDate)
    }, [startDate, endDate])


    const userAdmin = JSON.parse(StorageService.getItem("user_info"))

    const handleStore = useCallback((e) => {
        setStore(e)
    }, [store])
    const [pageSize, setPageSize] = useState(7)

    const handleSortBy = useCallback((e) => {
        setSortBy(e)
    }, [sortBy]);

    useLayoutEffect(() => {
        setLoading(true)
        fetchData(store, endDate, startDate, sortBy)
    }, [store, endDate, startDate, sortBy])
    
    const fetchData = async (s, eD, sD, sBy) => {
        const rs = await axiosService(`api/reports/store/work/total-price-booking?storeId=${s}&startDate=${sD}&endDate=${eD}&sortBy=${sBy}`, "GET")
        const { data } = rs.data
        if (rs.status == 200) {
            setTotalPaid(data.totalMore)
            setTotalOrderNew(data.totalPaid)
            setTotalOrderTriet(data.totalAll)
            setRows(data.dataTable)


            let rowsCountBooking = []
            let rowsCountBookingSuccess = []
            let rowsCountBookingService = []
            for (let item of data.dataTable.reverse()) {
                let rowCountBooking = {
                    date: item.date,
                    value: item.totalMore,
                    type: 'Doanh thu dự kiến'
                }
                let rowCountBookingSuccess = {
                    date: item.date,
                    value: item.totalPaid,
                    type: 'Thực thu dự kiến'
                }
                let rowCountBookingService = {
                    date: item.date,
                    value: item.totalAll,
                    type: 'Thực thu'
                }
                rowsCountBooking.push(rowCountBooking)
                rowsCountBookingSuccess.push(rowCountBookingSuccess)
                rowsCountBookingService.push(rowCountBookingService)
            }
            setOrdersByDaysCountBooking([...rowsCountBooking, ...rowsCountBookingSuccess, ...rowsCountBookingService])
            let value = "yyyy-MM-dd"
                if (sortBy === 1) {
                    value = "ww"
                } else if (sortBy === 2) {
                    value = "MM"
                }
            setLoading(false)
        }
    
    }
    function convertCurrency(data) {
        let res = new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(data)
        return res;
    };

    const config = useMemo(() => configChart(ordersByDaysCountBooking, convertCurrency), [ordersByDaysCountBooking])
    
    const handleExportData = () => {
        setIsExport(true)
        setTimeout(() => {
            setIsExport(false)
        }, 2000)
    }
    
    const  handleChange = (e) => {
        setPageSize(e.pageSize)
    }


    return (
        <div className={`${styles.background} container-fluid report-page`}>
            <FilterReport startDate={startDate} endDate={endDate}
                handleRangeDate={handleRangeDate} store={store}
                handleStore={handleStore}
                sortBy={sortBy} handleSortBy={handleSortBy}
                title={"Doanh thu dự kiến"} type={"projected-revenue"}
                csvData={rows} isExport={isExport}
                handleExportData={handleExportData}
                header={
                    [
                        { label: 'Thời gian', key: "date" },
                        { label: "Doanh thu dự kiến", key: "totalMore" },
                        { label: "Đã thu", key: "totalPaid" },
                        { label: "Tổng thực thu", key: "totalAll" },
                    ]
                }
                userAdmin={userAdmin}
            />
            <Spin spinning={loading}>
                <Row className="mt-2">
                    <Col xs={12} md={8}>
                        <Row className="h-100">
                            <Col xs={6} md={3}>
                                <Tag color="blue" className="w-100 p-2 h-100">
                                    <span className={styles.textTag3}>
                                    <Tooltip className="show-tooltip" title='Tông tiền những đơn hàng nợ phải thu từ khách hàng hẹn lịch đến làm dịch vụ lần đầu tiên'> Tổng doanh thu dự kiến  <i className="fas fa-info-circle"></i></Tooltip>
                                    </span>
                                    <div className="d-flex justify-content-between">
                                        <div>
                                            <span className={styles.textTag}> </span>
                                            <br />
                                        </div>
                                        <div className="ml-3">
                                            <span className={styles.textTag}>
                                                {convertCurrency(totalPaid)}</span>
                                        </div>
                                    </div>
                                </Tag>
                            </Col>

                            <Col xs={6} md={3} className="pay_type">                   
                                <Tag color="blue" className="w-100 p-2 h-100">
                                    <span className={styles.textTag3}>
                                    <Tooltip className="show-tooltip" title='Tổng tất cả tiền khách hàng đến thanh toán nợ hoặc mua mới đơn hàng trong thời gian.'> Tổng tiền thực thu  <i className="fas fa-info-circle"></i></Tooltip> </span>
                                    <div className="d-flex justify-content-between">
                                        <div>
                                            <span className={styles.textTag}> </span>
                                            <br />
                                        </div>
                                        <div className="ml-3">
                                            <span className={styles.textTag}>
                                                {convertCurrency(totalOrderTriet)}</span>
                                        </div>
                                    </div>
                                </Tag>
                            </Col>
                            <Col xs={6} md={3} className="pay_type">                   
                                <Tag color="blue" className="w-100 p-2 h-100">
                                    <span className={styles.textTag3}>
                                    <Tooltip className="show-tooltip" title='Tổng tiền đã thu từ những khách hẹn lịch, đến làm dịch vụ thành công và thanh toán tiền.'> Thực thu dự kiến  <i className="fas fa-info-circle"></i></Tooltip>
                                    </span>
                                    <div className="d-flex justify-content-between">
                                        <div>
                                            <span className={styles.textTag}> </span>
                                            <br />
                                        </div>
                                        <div className="ml-3">
                                            <span className={styles.textTag2}> {convertCurrency(totalOrderNew)}</span>
                                        </div>
                                    </div>
                                </Tag>
                            </Col>
                        
                        
                        </Row>
                    </Col>
                </Row>
                <Row className="mt-2">
                    <Col xs={12} md={5} className="hide-mobile">
                        <div style={{ backgroundColor: "white" }} className="p-2">
                            <Line {...config} />
                        </div>
                    </Col>
                    <Col xs={12} md={7}>
                        <div style={{ backgroundColor: "white" }} >
                            <div className="border-bottom mb-1 p-2">
                                <strong className="m-2">Bảng dữ liệu chi tiết</strong>
                            </div>
                            <div style={{ width: '100%' }} className="p-2">
                                <Table 
                                    columns={columns} 
                                    dataSource={rows}
                                    pagination={{ pageSize: pageSize, showSizeChanger: true, pageSizeOptions: ['7', '15', '30', '50', '100'] }}
                                    scroll={{ x: columns.length*200, y: 1200 }}
                                    onChange={handleChange}
                                    bordered
                                    rowKey="date"
                                />
                            </div>
                        </div>
                    </Col>
                </Row>
            </Spin>
        </div >

    )
}
const configChart = (data, convertCurrency) => {  
    var config = {
        data: data,
        xField: "date",
        yField: "value",
        seriesField: "type",
        height: 520,
        xAxis: {
          title: {
            text: "Thời gian",
            position: "end",
            offset: 0,
            spacing: 8,
            style: {
              fontSize: 13,
              fontWeight: 900,
              textAlign: "start"
            }
          },
          line: {
            style: {
              stroke: "black"
            }
          },
          tickLine: {
            style: {
              stroke: "black"
            }
          },
          label: {
            autoRotate: true,
            style: {
              fill: "black",
            //   fontSize: 10
            },
            formatter: (text) => {
              const oldLabel = text;
              const labelLength = oldLabel.replace(/[^x00-xff]/g, "xx").length;
              let newLabel = "";
              if (labelLength > 12) {
                let strLen = 0;
                let firstStr = "";
                let lastStr = "";
                for (let i = 0; i < labelLength; i++) {
                  if (oldLabel.charCodeAt(i) > 128) {
                    strLen += 2;
                  } else {
                    strLen++;
                  }
                  if (strLen <= 12) {
                    firstStr += oldLabel.charAt(i);
                  } else {
                    lastStr += oldLabel.charAt(i);
                  }
                }
                newLabel = `${firstStr}\n${lastStr}`;
              } else {
                newLabel = oldLabel;
              }
              return newLabel;
            }
          }
        },
        yAxis: {
          line: {
            style: {
              lineWidth: 2
            }
          },
          label: {
            style: {
              fill: "black"
            },
            offset: 15,
            formatter: (text) => _.round(_.divide(text, 1), 2).toLocaleString()
          }
        },
        color: ["#673ab7", "#2196f3", "#4caf50"],
        legend: {
          position: "right",
          marker: {
            symbol: "square"
          },
          itemName: {
            formatter: (text, item, index) => {
    
              return '';
            }
          }
        },
        point: [{
            size: 3,
            shape: 'circle',
            style: {
                fill: 'blue',
                stroke: '#673ab7',
                lineWidth: 2,
            },
        }, {
            size: 3,
            shape: 'circle',
            style: {
                fill: 'blue',
                stroke: '#2196f3',
                lineWidth: 2,
            },
        },
        {
            size: 3,
            shape: 'circle',
            style: {
                fill: 'blue',
                stroke: '#4caf50',
                lineWidth: 2,
            },
        }],
        tooltip: {
            customContent: (count, data) => {
                let fileHtml = ''
                let title = ''
                for(let item of data) {
                    title = item.title
                    let value = convertCurrency(item.value)
                    fileHtml += '<li class="g2-tooltip-list-item">'
                    fileHtml += '<span class="g2-tooltip-marker" style="background: '+item.color+'; width: 8px; height: 8px; border-radius: 50%; display: inline-block; margin-right: 8px;">' + '</span>'
                    fileHtml += '<span class="g2-tooltip-name" style="color: '+item.color+';">'+item.name + '</span>'
                    fileHtml += '<span class="g2-tooltip-value" style="color: '+item.color+';">'+ value + '</span>'
                    fileHtml += '</li>'
                }
                return `<div class="g2-tooltip-title" style="margin-bottom: 12px; margin-top: 12px; padding-top: 12px; font-weight: bold; font-size: 15px"><p> ${title} </div>
                    <ul class="g2-tooltip-list" style="margin: 0px; list-style-type: none; padding: 12px !important; ">
                        ${fileHtml}
                        </br>
                    </ul>
                </div>`;
            }
        },
      };
    return config
}
export default ReportStoreBooingPrice